import { z } from 'zod';
import { HASHTAG_PATTERN } from './content.js';
/** Snapshot key of module 40's own contributor for format texts (spec 40 §4.4a, S130-17). */
export const VARIANT_TEXTS_SNAPSHOT_KEY = 'variant_texts';
/**
 * One format's own texts for one localization (spec 40 §4.4a): each field
 * replaces the shared one; `null` keeps the shared one (E260, S260-6).
 */
export const variantTextSchema = z
    .object({
    variant_id: z.string().uuid(),
    localization_id: z.string().uuid(),
    caption: z.string().max(10000).nullable(),
    cta: z.string().max(300).nullable(),
    hashtags: z.array(z.string().regex(HASHTAG_PATTERN)).nullable(),
})
    .strict();
/** The format texts stored in a version snapshot (`contributions.variant_texts`), or none. */
export function snapshotVariantTexts(snapshot) {
    const part = snapshot.contributions[VARIANT_TEXTS_SNAPSHOT_KEY];
    return part === undefined ? [] : z.array(variantTextSchema).parse(part);
}
/**
 * The texts a format publishes in one localization (spec 40 §4.4a): each
 * field it overrides (caption, CTA, hashtags), otherwise the localization's.
 * Preview, module 50's `text_too_long` and module 70's caption all read this.
 */
export function effectiveTexts(shared, override) {
    if (!override)
        return { caption: shared.caption, cta: shared.cta, hashtags: shared.hashtags };
    return { caption: override.caption ?? shared.caption, cta: override.cta ?? shared.cta, hashtags: override.hashtags ?? shared.hashtags };
}
/** The override of a variant and localization in a list of format texts, or `null`. */
export function variantTextOf(texts, variantId, localizationId) {
    return texts.find((text) => text.variant_id === variantId && text.localization_id === localizationId) ?? null;
}
//# sourceMappingURL=variant-texts.js.map